import MerchantMessagesPage from '../pages/MerchantMessagesPage.vue';

const merchantMessagesRoutes = [
  {
    path: '/merchant-messages',
    name: 'پیام های شما',
    component: MerchantMessagesPage,
    meta: {
      roles: ['merchant','supplier'],
    },
  },
];

export default merchantMessagesRoutes;
